var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"badge-list"},_vm._l((_vm.badgeList),function(badge,index){return _c('li',{key:index,staticClass:"right-top-area"},[_c(_setup.badgeComponent,{key:`${index}__${badge}__${_vm.type}`,tag:"component",attrs:{"badge":badge}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }